import { maintenanceSyncService } from '~/lib/pwa/maintenanceSyncService';
import { profileSyncService } from '~/lib/pwa/profileSyncService';
import { entitySyncService } from '~/lib/pwa/entitySyncService';

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.server) return;

  const isOnline = useState('is-online', () => navigator.onLine);
  const toast = useToast();

  const handleOnline = async () => {
    isOnline.value = true;

    toast.add({
      color: 'success',
      icon: 'i-lucide-wifi',
      title: 'Conexão Restabelecida',
      description: 'Você está online novamente. Os dados em cache serão sincronizados em breve.',
      duration: 2000
    });

    try {
      await profileSyncService.syncPending();
      await entitySyncService.syncPending();
      await maintenanceSyncService.syncPending();
    } catch (error) {
      console.error('Erro ao sincronizar dados pendentes:', error);
    }
  };

  const handleOffline = () => {
    isOnline.value = false;

    toast.add({
      color: 'warning',
      icon: 'i-lucide-wifi-off',
      title: 'Modo Offline',
      description: 'Você está usando dados em cache. Algumas funcionalidades podem estar limitadas.',
      duration: 3000
    });
  };

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  nuxtApp.provide('isOnline', isOnline);
});
